/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ContentChildren, ElementRef, Input, QueryList } from '@angular/core';
import { FeRadioGroup } from '../form-elements/fe-radio-group/fe-radio-group';
import { FeText } from '../form-elements/fe-text/fe-text';
import { FeSelect } from '../form-elements/fe-select/fe-select';
import { FeSwitcher } from '../form-elements/fe-switcher/fe-switcher';
import { FeRadio } from '../form-elements/fe-radio/fe-radio';
import { FeCheckbox } from '../form-elements/fe-checkbox/fe-checkbox';
import { FeButton } from '../form-elements/fe-button/fe-button';
import { UiGroup } from '../ui-group';
import { Filterable } from '../../mixins/Filterable';
import { Mixin } from '../../mixins/Mixin';

@Component({
    selector: 'ui-form-group',
    template: require('./ui-form-group.html'),
    styles: [require('./ui-form-group.less')],
})
@Mixin([Filterable])
export class UiFormGroup {

    @ContentChildren(FeText) feTextList: QueryList<FeText>;
    @ContentChildren(FeCheckbox) feCheckboxList: QueryList<FeCheckbox>;
    @ContentChildren(FeRadio) feRadioList: QueryList<FeRadio>;
    @ContentChildren(FeRadioGroup) feRadioGroupList: QueryList<FeRadioGroup>;
    @ContentChildren(FeButton) feButtonList: QueryList<FeButton>;
    @ContentChildren(FeSwitcher) feSwitcherList: QueryList<FeSwitcher>;
    @ContentChildren(FeSelect) feSelectList: QueryList<FeSelect>;

    @Input() title: string = '';
    @Input() boldTitle: boolean = true;
    @Input() description: string = '';

    @Input() highlightPhrase: string = '';

    constructor(public elementRef: ElementRef) {}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-form-group/ui-form-group.ts